import moment from 'moment'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import GatheringRegistrationModal from 'main/components/school/GatheringRegistrationModal'
import { gatheringPath } from 'main/routes'
import { Calendar, Strong, Text } from 'main/ui'
import { humanReadableGatheringType } from 'main/util/gathering'

import { SchoolPage_school_upcomingGatherings } from '../../gql'
import {
  Container,
  DetailsContainer,
  InfoContainer,
  StyledButton,
} from './UpcomingGatheringListing.styles'

interface IProps {
  schoolId: number
  upcomingGathering: SchoolPage_school_upcomingGatherings
}

export default function UpcomingGatheringListing(props: IProps) {
  const { schoolId, upcomingGathering } = props

  const [modal, setModal] = React.useState<boolean>(false)
  const { t } = useTranslation(NAMESPACE)

  return (
    <Container>
      <DetailsContainer href={gatheringPath(upcomingGathering)} target="_blank">
        <Calendar date={upcomingGathering.beginsAt} />
        <InfoContainer>
          <Strong style={{ fontSize: `13px` }}>
            {t(humanReadableGatheringType(upcomingGathering.type))}
          </Strong>
          <Text muted style={{ fontSize: `13px` }}>
            {moment(upcomingGathering.beginsAt).format('dddd, MMM Do, h:mma')}
          </Text>
        </InfoContainer>
      </DetailsContainer>
      <StyledButton
        kind={upcomingGathering.myRegistration ? 'regular' : 'outline'}
        onClick={() => setModal(true)}
        disabled={false}
        small={false}
        full={false}
      >
        {upcomingGathering.myRegistration ? 'Going' : 'RSVP'}
      </StyledButton>
      {modal && (
        <GatheringRegistrationModal
          gathering={upcomingGathering}
          registration={upcomingGathering.myRegistration}
          schoolId={schoolId}
          onRequestClose={() => setModal(false)}
        />
      )}
    </Container>
  )
}
